import { Component, OnInit, DoCheck, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs';
import 'angular2-expandable-list';
import { ToastrService } from 'ngx-toastr';
import { TranslateService as langService } from '../../i18n/translate.service';
import { TranslatePipe } from '../../i18n/translate.pipe';
import { CommonService } from '../../Services/common.service';
import { AuthToken } from '../../Model/AuthToken.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { NewsletterSubscibermodel } from 'src/app/Model/newsletter-subscibermodel';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountDeleteModalComponent } from 'src/app/Modal/account-delete-modal/account-delete-modal.component';

declare var config;

@Component({
  selector: 'app-layout-dashboard',
  templateUrl: './layout-dashboard.component.html',
  styleUrls: ['./layout-dashboard.component.css']
})
export class LayoutDashboardComponent implements OnInit {
  public ClientWebsite = config.ClientWebsite;
  public ClientPrivacyPolicy = config.ClientPrivacyPolicy;
  public ClientTermsConditions = config.ClientTermsConditions;
  public ClientHowitWorks = config.ClientHowitWorks;
  public ClientAboutus = config.ClientAboutus;
  private GetIPUrl: string;

  public UserInfo: any;
  public TokenData: AuthToken;
  public userMenus: any[];
  public islogin: boolean = false;
  AutoCompleteSearchModelsArray = [,];
  public CustomerInfo: any;
  language = "en";
  public translatePipe: any;
  public Listlanguage: any;
  public Listcurrency: any;
  ipAddress: any;
  subscribermodel: NewsletterSubscibermodel;
  formSubscriber: FormGroup;
  SubscriberSuccessMessage: boolean;
  public IsSubmitted: boolean;
  public IsInvalid: boolean;
  LanguageID: string;
  FacebookUrl: string;
  StoreLocator: string;
  TwitterUrl: string;
  InstagramUrl: string;
  PinterestUrl: string;
  ContactEmail: string;
  showLanguage: boolean;
  YoutubeUrl: string;
  @ViewChild('hideNav') hideNav: ElementRef<HTMLElement>;
  subscriberEmail: string;
  languageCode: any;
  routeLanguageCode: any;
  userdetails: any;
  mailsentnotification: boolean = false;
  EmailAddress: any;
  constructor(private fb: FormBuilder, private router: Router, private toastr: ToastrService, private _service: CommonService, private _translatelang: langService,
    private spinner: NgxSpinnerService, private httpClient: HttpClient, private el: ElementRef
    , private modalService: NgbModal) {
    this.showLanguage = config.ShowLanguage;
    this.ContactEmail = config.ContactEmail;
    this.translatePipe = new TranslatePipe(_translatelang);
    this.FacebookUrl = config.FacebookUrl;
    this.StoreLocator = config.StoreLocator;
    this.TwitterUrl = config.TwitterUrl;
    this.InstagramUrl = config.InstagramUrl;
    this.PinterestUrl = config.PinterestUrl;
    this.YoutubeUrl = config.YoutubeUrl;
    const language = sessionStorage.getItem('language');
    this.formSubscriber = fb.group({
      SubscriberEmail: [
        null,
        Validators.compose([
          Validators.required,
          _service.noWhitespaceValidator,
          Validators.maxLength(50)
        ])
      ],
    });
    debugger;
    // this.languageCode = window.location.href.split('=')[1];
    if (language) {
      this.language = language;
    }
    // else if (this.languageCode) {
    //   sessionStorage.setItem('language', this.languageCode);
    //   this._translatelang.use(this.languageCode);
    // } 
    else {
      this.language = config.ML_Language;
      this.LanguageID = config.ML_LanguageID;
      sessionStorage.setItem('LanguageID', this.LanguageID);
      sessionStorage.setItem('language', this.language);
    }
    this.GetIPUrl = config.GetIPUrl;
  }

  ngDoCheck() {
    this.CustomerInfo = JSON.parse(sessionStorage.getItem('customerinfo'));
    if (this.CustomerInfo !== null && this.CustomerInfo !== undefined && this.CustomerInfo.CustomerID > 0) {
      this.islogin = true;
    }
    else {
      this.islogin = false;
    }


  }
  GetLanguage() {
    this.Listlanguage = JSON.parse(sessionStorage.getItem('Listlanguage'));
    this.UserInfo = JSON.parse(sessionStorage.getItem('userinfo'));
    var EnterprisePartnerID = this.UserInfo.EnterprisePartnerID;
    this._service.Get('api/GetLanguage/' + EnterprisePartnerID).then(data => {
      if (data.length > 0) {
        debugger;
        this.Listlanguage = data;
        this.Listlanguage = data;
        if (this.languageCode) {
          let selectedLanguage = data.filter(x => x.LanguageCode == this.languageCode);
          if (selectedLanguage.length > 0) {
            sessionStorage.setItem('LanguageID', selectedLanguage[0].LanguageID);
            sessionStorage.setItem('language', selectedLanguage[0].LanguageCode);
            this._translatelang.use(selectedLanguage[0].language);
            this.language = selectedLanguage[0].LanguageCode;
            this.routeLanguageCode = selectedLanguage[0].LanguageCode;
            var ddlLanguage = document.getElementById('ddlLanguage') as HTMLInputElement;
            ddlLanguage.value = selectedLanguage[0].LanguageCode;
          } else {
            this.GetBrowserLanguage(data);
          }
        } else {
          this.GetBrowserLanguage(data);
        }

      }
    }, error => {
      this.router.navigate(['/error']);
    });
  }
  fnRoute(value) {
    this.router.navigateByUrl(value + "?languageCode=" + this.routeLanguageCode);
  }
  GetBrowserLanguage(data) {
    var language = sessionStorage.getItem('language');
    sessionStorage.setItem('Listlanguage', JSON.stringify(this.Listlanguage));
    if (language == null || language == '' || language == undefined) {
      var browserlanguage = navigator.language;
      if (browserlanguage === "en" || browserlanguage === "en-US") {
        this.language = "en";
        // data = this.Listlanguage.filter(a => a.LanguageCode ==this.language);
        sessionStorage.setItem('LanguageID', data[0].LanguageID);
        sessionStorage.setItem('language', data[0].LanguageCode);
        this._translatelang.use(data[0].language);
        this.routeLanguageCode = data[0].LanguageCode;
      }
      // else if (browserlanguage === "fr-FR" || browserlanguage === "fr") {
      //   this.language="fr";
      //   data = this.Listlanguage.filter(a => a.LanguageCode == this.language);
      //   sessionStorage.setItem('LanguageID', data[0].LanguageID);
      //   sessionStorage.setItem('language', data[0].LanguageCode);
      //   this._translatelang.use(data[0].language);
      // }
      else if (browserlanguage === "nl") {
        this.language = "nl";
        data = this.Listlanguage.filter(a => a.LanguageCode == this.language);
        sessionStorage.setItem('LanguageID', data[0].LanguageID);
        sessionStorage.setItem('language', data[0].LanguageCode);
        this._translatelang.use(data[0].language);
        this.routeLanguageCode = data[0].LanguageCode;
      }
      else {
        this.language = "nl";
        data = this.Listlanguage.filter(a => a.LanguageCode == this.language);
        sessionStorage.setItem('LanguageID', data[0].LanguageID);
        sessionStorage.setItem('language', data[0].LanguageCode);
        this._translatelang.use(data[0].language);
        this.routeLanguageCode = data[0].LanguageCode;
      }
    }
    else {
      data = this.Listlanguage.filter(a => a.LanguageCode == language);
      sessionStorage.setItem('LanguageID', data[0].LanguageID);
      sessionStorage.setItem('language', data[0].LanguageCode);
      this._translatelang.use(data[0].language);
      this.routeLanguageCode = data[0].LanguageCode;
    }
  }

  GetCurrency() {
    debugger
    this.UserInfo = JSON.parse(sessionStorage.getItem('userinfo'));
    //var language = sessionStorage.getItem('language');
    var EnterprisePartnerID = this.UserInfo.EnterprisePartnerID;
    this._service.Get('api/GetCurrency/' + EnterprisePartnerID).then(data => {
      if (data.length > 0) {
        this.Listcurrency = data;

        sessionStorage.setItem('ListCountry', JSON.stringify(this.Listcurrency));
      }
    }, error => {
      this.router.navigate(['/error']);
    });
  }

  removeNavBar() {
    if (this.hideNav.nativeElement.classList.contains('in')) {
      this.hideNav.nativeElement.classList.remove('in');
    }
    if (this.hideNav.nativeElement.classList.contains('open')) {
      this.hideNav.nativeElement.classList.remove('open');
    }
  }
  removeLoginNavBar() {
    if (this.hideNav.nativeElement.classList.contains('open')) {
      this.hideNav.nativeElement.classList.remove('open');
    }
  }

  ngOnInit() {
    debugger
    this.UserInfo = JSON.parse(sessionStorage.getItem('userinfo'));
    if (this.UserInfo === null || this.UserInfo === undefined && this.UserInfo !== "") {
      this.getIpAddress();
    }
    else {
      // this.GetLanguage();
      this.GetCurrency();
      this.islogin = true;
    }
  }

  getIpAddress() {
    this.ipAddress = sessionStorage.getItem('IpAddress');
    if (this.ipAddress === null || this.ipAddress === undefined) {
      this.httpClient.get<{ ip: string }>(this.GetIPUrl).subscribe(response => {
        this.ipAddress = response.ip;
        sessionStorage.setItem('IpAddress', this.ipAddress.toString());
        this.loginUser();
      },
        err => {
          console.log(err);
          this.loginUser();
        },

      )
    }
    else {
      this.loginUser();
    }
  }

  loginUser() {

    const UserStoreLogin = {
      UserName: config.UserName,
      Password: config.Password,
    };

    this.UserInfo = JSON.parse(sessionStorage.getItem('userinfo'));
    this._service.PostLogin(UserStoreLogin, 'api/UserLogin/GetUserStoreLogin').then(result => {

      if (result == null || result.length <= 0 || !result.IsValidUser || result.Store == '' || result.Store == null) {

      }
      else {

        sessionStorage.setItem('userinfo', JSON.stringify(result));

        this.TokenData = new AuthToken();
        this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
        if (this.TokenData === null || this.TokenData === undefined) {

          this.UserInfo = JSON.parse(sessionStorage.getItem('userinfo'));
          const userdata = {
            Username: this.UserInfo.UserName,
            Password: config.Password,
            grant_type: 'password',
          }
          this._service.PostToken(userdata, 'token').then(result => {
            if (result !== undefined) {
              this.TokenData = new AuthToken();
              this.TokenData.access_token = result.access_token;
              this.TokenData.expires_in = result.expires_in;
              this.TokenData.refresh_token = result.refresh_token;
              this.TokenData.token_type = result.token_type;
              sessionStorage.setItem('Token', JSON.stringify(this.TokenData));
              console.log(this.TokenData);

              // this.GetLanguage();
              this.GetCurrency();
            }
            else {

              console.log('error - GenrateToken');
            }

          },
            error => {

              if (error.status === 401) {
                this.router.navigate(['/unauthorized']);
              }
              console.log(error);
              throw error;
            });
        }
        else {

          // this.GetLanguage();
          this.GetCurrency();
        }

      }
    },
      error => {

        console.log(error);
      });
  }

  fnLogout() {
    var languageID = sessionStorage.getItem('LanguageID');
    var language = sessionStorage.getItem('language');
    sessionStorage.clear();
    this.clearBrowserBackHistory();
    this.islogin = false;
    this.router.navigateByUrl('/');
    this.toastr.success(this.translatePipe.transform("Layout.User_Logout_Successfully"));
    sessionStorage.setItem('LanguageID', languageID);
    sessionStorage.setItem('language', language);
  }

  fnGoToHome() {
    this.UserInfo = JSON.parse(sessionStorage.getItem('userinfo'));
    this.TokenData = JSON.parse(sessionStorage.getItem('Token'));
    this.AutoCompleteSearchModelsArray = JSON.parse(sessionStorage.getItem('AutoCompleteSearchModelsArray'));
    sessionStorage.clear();
    sessionStorage.setItem('userinfo', JSON.stringify(this.UserInfo));
    sessionStorage.setItem('Token', JSON.stringify(this.TokenData));
    sessionStorage.setItem('AutoCompleteSearchModelsArray', JSON.stringify(this.AutoCompleteSearchModelsArray));

    this.router.navigate(['/search']);
  }

  clearBrowserBackHistory(): void {
    history.pushState(null, null, location.href);
    window.onpopstate = function (event) {
      history.go(1);
    };
  }
  LoginUser() {
    this.router.navigate(['/login']);
  }
  RegisterClick() {
    this.router.navigate(['/register']);
  }
  setLanguage() {
    var element = document.getElementById("CosmeticGrade");
    if (element != null)
      element.classList.remove("active");
    if (this.language == null) {
      this.language = config.ML_Language;
    }
    sessionStorage.setItem('language', this.language);
    var data = this.Listlanguage.filter(a => a.LanguageCode == this.language);
    sessionStorage.setItem("LanguageID", data[0].LanguageID);
    this._translatelang.use(this.language);
    this.routeLanguageCode = this.language;
  }

  SaveNewsletterSubscriber() {
    debugger

    this.IsSubmitted = true

    this.UserInfo = JSON.parse(sessionStorage.getItem('userinfo'));
    this.subscribermodel = new NewsletterSubscibermodel();
    this.subscribermodel.EmailAddress = this.formSubscriber.value.SubscriberEmail;
    this.subscribermodel.EnterprisePartnerID = this.UserInfo.EnterprisePartnerID;

    setTimeout(() => {
      this.IsInvalid = false;
      this.SubscriberSuccessMessage = false;
    }, 5000);
    if (this.IsSubmitted && this.subscribermodel.EmailAddress == null) {
      this.IsInvalid = true;
      return false;
    }

    if (this.IsSubmitted && this.subscribermodel.EmailAddress == null) {
      this.IsInvalid = true;
      return false;
    }

    else if ((!this._service.IsValidEmail(this.subscribermodel.EmailAddress))) {
      this.IsInvalid = true;
      return false;
    }
    else {
      this._service.PostNewsletterSubscriber(this.subscribermodel, 'api/NewsletterSubscriber/SaveNewsletterSubscriber').then(result => {
        debugger
        if (this.IsSubmitted && this.subscribermodel.EmailAddress != null) {
          this.IsInvalid = false;
          this.SubscriberSuccessMessage = true;
          this.subscriberEmail = "";
        }

      });
    }


  }
  deleteClick() {
    this.spinner.show();
    this.modalService.open(AccountDeleteModalComponent);
  }

}
